import { useState } from 'react';

const useScrollUp = () => {
  const [scrollingUp, setScrollingUp] = useState(true);
  const [prevScroll, setPrevScroll] = useState(0);
  const handleScroll = (e: React.UIEvent<HTMLElement>, minScroll: number) => {
    if (e.currentTarget) {
      const currScroll = e.currentTarget.scrollTop;
      const isScrolled = prevScroll > currScroll || currScroll <= minScroll;
      setScrollingUp(isScrolled);
      setPrevScroll(currScroll);
    }
  };

  return { scrollingUp, handleScroll };
};

export default useScrollUp;
